import React from 'react';
import { motion } from 'framer-motion';
import { tools } from '../data/tools';
import { ToolLogo } from './Logos';
export function ToolProfiles() {
  return <section id="tools" className="py-24 bg-blueprint relative" data-id="element-254">
      <div className="absolute inset-0 bg-scanlines pointer-events-none opacity-30" data-id="element-255" />

      <div className="max-w-[90rem] mx-auto px-4 sm:px-6 lg:pl-24 lg:pr-8 relative z-10" data-id="element-256">
        <div className="mb-16 font-mono" data-id="element-257">
          <div className="text-lime text-xs tracking-widest mb-4" data-id="element-258">
            §02 / DOSSIERS
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-ink uppercase tracking-tight mb-6" data-id="element-259">
            System Profiles
          </h2>
          <p className="text-ink/60 text-sm max-w-2xl leading-relaxed hairline-l pl-6 border-ink/20" data-id="element-260">
            A balanced look at the major players. Every tool has strengths, and
            every tool has trade-offs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-261">
          {tools.map((tool, i) => {
          const isWaydev = tool.id === 'waydev';
          return <motion.div key={tool.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05,
            ease: 'easeOut'
          }} className={`relative flex flex-col bg-base ${isWaydev ? 'hairline-all border-lime shadow-[0_0_30px_rgba(196,240,66,0.1)]' : 'hairline-all hover:border-ink/40'} transition-all duration-300 group`} data-id="element-262">
                {/* File Tab Header */}
                <div className={`flex items-center justify-between px-4 py-2 hairline-b font-mono text-[10px] tracking-widest ${isWaydev ? 'bg-lime text-base font-bold' : 'bg-ink/5 text-ink/50'}`} data-id="element-263">
                  <span data-id="element-264">DOSSIER · {String(i + 1).padStart(3, '0')}</span>
                  {isWaydev && <span data-id="element-265">PRIMARY SYSTEM</span>}
                </div>

                <div className="p-6 flex-grow flex flex-col" data-id="element-266">
                  <div className="flex items-start gap-4 mb-6" data-id="element-267">
                    <div className={`w-12 h-12 flex items-center justify-center shrink-0 ${isWaydev ? 'bg-lime/10' : 'bg-ink/5'} hairline-all`} data-id="element-268">
                      <ToolLogo toolId={tool.id} className={isWaydev ? 'stroke-lime' : ''} data-id="element-269" />
                    </div>
                    <div data-id="element-270">
                      <h3 className="font-display text-2xl font-bold text-ink uppercase tracking-tight" data-id="element-271">
                        {tool.name}
                      </h3>
                      <div className="font-mono text-[10px] text-ink/40 mt-1 uppercase" data-id="element-272">
                        ID: {tool.id.toUpperCase()}_SYS
                      </div>
                    </div>
                  </div>

                  <div className="font-mono text-xs text-ink/70 mb-6 pb-6 hairline-b leading-relaxed" data-id="element-273">
                    {tool.tagline}
                  </div>

                  <div className="flex-grow space-y-6 font-mono text-xs" data-id="element-274">
                    <div data-id="element-275">
                      <div className="text-ink/40 mb-2 tracking-widest" data-id="element-276">
                        OPT: BEST FOR
                      </div>
                      <div className={`px-2 py-1 inline-block ${isWaydev ? 'bg-lime/20 text-lime' : 'bg-ink/10 text-ink'}`} data-id="element-277">
                        {tool.bestFor.toUpperCase()}
                      </div>
                    </div>

                    <div data-id="element-278">
                      <div className="text-ink/40 mb-2 tracking-widest" data-id="element-279">
                        STRENGTHS [+]
                      </div>
                      <ul className="space-y-2" data-id="element-280">
                        {tool.strengths.map((str, idx) => <li key={idx} className="flex items-start gap-2 text-ink/80" data-id="element-281">
                            <span className="text-lime mt-px" data-id="element-282">+</span>
                            <span className="leading-tight" data-id="element-283">{str}</span>
                          </li>)}
                      </ul>
                    </div>

                    <div data-id="element-284">
                      <div className="text-ink/40 mb-2 tracking-widest" data-id="element-285">
                        WATCH-OUTS [-]
                      </div>
                      <ul className="space-y-2" data-id="element-286">
                        {tool.watchOuts.map((wo, idx) => <li key={idx} className="flex items-start gap-2 text-ink/50" data-id="element-287">
                            <span className="text-amber-500 mt-px" data-id="element-288">-</span>
                            <span className="leading-tight" data-id="element-289">{wo}</span>
                          </li>)}
                      </ul>
                    </div>
                  </div>

                  <div className="mt-8 pt-4 hairline-t flex flex-col gap-2 font-mono text-[10px] text-ink/40 tracking-widest" data-id="element-290">
                    <div className="flex justify-between" data-id="element-291">
                      <span data-id="element-292">MODEL:</span>
                      <span className="text-ink/80" data-id="element-293">
                        {tool.pricingModel.toUpperCase()}
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-294">
                      <span data-id="element-295">DEPLOY:</span>
                      <span className="text-ink/80" data-id="element-296">
                        {tool.deployment.toUpperCase()}
                      </span>
                    </div>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}